import { Download } from "@monta/icons";
import styles from "./styles.module.scss";

const DownloadBtn = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className={styles["download-container"]}>
      <div className={styles["download-container__title"]}>
        اطلاعات کلی کارنامه
      </div>
      <div className={styles["download-container__download"]} onClick={onClick}>
        دانلود کارنامه
        <Download size={15} />
      </div>
    </div>
  );
};

export default DownloadBtn;
